/**
 * @generated SignedSource<<352c7d120d8636a546da61d7ab7e4628>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type pullRequestCommentSuggestions_periscope_PullRequestCommentTask$data = {
  readonly __typename: "WorkSuggestionsPRCommentsTask";
  readonly approvalsCount: number;
  readonly commentCount: number;
  readonly comments: ReadonlyArray<{
    readonly avatar: string | null | undefined;
    readonly commenterName: string;
    readonly text: string;
    readonly url: string;
  }> | null | undefined;
  readonly destinationBranchName: string | null | undefined;
  readonly id: string;
  readonly repositoryName: string | null | undefined;
  readonly title: string;
  readonly url: string;
  readonly " $fragmentType": "pullRequestCommentSuggestions_periscope_PullRequestCommentTask";
};
export type pullRequestCommentSuggestions_periscope_PullRequestCommentTask$key = {
  readonly " $data"?: pullRequestCommentSuggestions_periscope_PullRequestCommentTask$data;
  readonly " $fragmentSpreads": FragmentRefs<"pullRequestCommentSuggestions_periscope_PullRequestCommentTask">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "url"
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "pullRequestCommentSuggestions_periscope_PullRequestCommentTask",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__typename"
    },
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "kind": "ScalarField",
      "name": "title"
    },
    (v0/*: any*/),
    {
      "kind": "ScalarField",
      "name": "approvalsCount"
    },
    {
      "kind": "ScalarField",
      "name": "commentCount"
    },
    {
      "kind": "ScalarField",
      "name": "repositoryName"
    },
    {
      "kind": "ScalarField",
      "name": "destinationBranchName"
    },
    {
      "concreteType": "WorkSuggestionsPRComment",
      "kind": "LinkedField",
      "name": "comments",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "avatar"
        },
        {
          "kind": "ScalarField",
          "name": "text"
        },
        {
          "kind": "ScalarField",
          "name": "commenterName"
        },
        (v0/*: any*/)
      ]
    }
  ],
  "type": "WorkSuggestionsPRCommentsTask"
};
})();

(node as any).hash = "02868f43a3081817f41bf0bf69e404ed";

export default node;
